import { styled } from "theme/default/styled";
import { setFlexDF } from "theme/setter/setFlexValues/setFlexDF";

export const SAdditionalInfoStepButtons = styled.div`
  margin-top: 20px;

  ${setFlexDF};
`;
